import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Tooltip } from 'antd';

import { selectDictionary } from 'features/dictionaries/dictionariesSelectors';

import { Application } from 'types/applications';

import { Dictionaries } from 'constants/enums';

import styles from './SkillMatch.module.scss';
import SkillsetItem from './SkillsetItem/SkillsetItem';

interface SkillMatchProps {
  matchData?: Application['matchData'];
  skillsetMatchLabel?: string;
  skillsetsAll?: string[];
  skillsetsMatches?: string[];
}

const SkillMatch = ({
  matchData,
  skillsetMatchLabel,
  skillsetsAll,
  skillsetsMatches
}: SkillMatchProps) => {
  const { t } = useTranslation();
  const skillsetsDictionary = useSelector(
    selectDictionary(Dictionaries.Skillset)
  );

  const label = matchData?.skillsetMatchLabel || skillsetMatchLabel;
  const skillsetsList = matchData?.skillsetsAll || skillsetsAll;
  const skillsetsMatchesList = matchData?.skillsetsMatches || skillsetsMatches;

  if (!label || !skillsetsList || !skillsetsMatchesList) {
    return null;
  }

  return (
    <Tooltip
      title={
        <div className={styles.tooltipWrapper}>
          {skillsetsList.map((skillset) => (
            <SkillsetItem
              key={skillset}
              skillset={skillset}
              skillsetsMatches={skillsetsMatchesList}
              skillsetsDictionary={skillsetsDictionary}
            />
          ))}
        </div>
      }
    >
      <div className={styles.wrapper}>
        <span className={styles.text}>
          {t('common.label.skillMatch', { skill: label })}
        </span>
      </div>
    </Tooltip>
  );
};

export default SkillMatch;
